import { audioHighlight } from './audio-highlight';

export let activated = false;
export let feedbackAudioAutoplay = false;
let audioIndex = 0;
let audioElements = [];
let audioPlaying = false;
let audioFinished = false;
export const audioPlayer = document.querySelector('#question-audio-player');
const correctFeedbackAlert = document.querySelector('#correct-feedback');
const audioToggleButton = document.querySelector('#question-audio-button');
const incorrectFeedbackAlert = document.querySelector('#incorrect-feedback');

if (audioToggleButton) {
    audioToggleButton.addEventListener('click', () => {
        if (audioPlaying) {
            pauseAudio();
            feedbackAudioAutoplay = false;
        } else {
            if (!activated || audioFinished) {
                activateInitialAudio();
            }

            playAudio();
            feedbackAudioAutoplay = true;
        }
    });
}

if (audioPlayer) {
    audioPlayer.addEventListener('ended', () => {
        audioFinished = audioIndex + 1 === audioElements.length;

        if (audioFinished) {
            pauseAudio();
        } else {
            audioIndex++;
            loadAudio();
            playAudio();
            audioHighlight.unhighlight(audioElements[audioIndex - 1]);
        }
    });
}

function activateInitialAudio() {
    setupAudioElements();
    resetAudioPlayback();
    activated = true;
}

function setupAudioElements() {
    audioElements = [...document.querySelectorAll('.question.current .answers input + label')];
    audioElements.unshift(document.querySelector('.question.current > div'));

    if (!correctFeedbackAlert.classList.contains('hidden')) {
        audioElements.push(correctFeedbackAlert);
    } else if (!incorrectFeedbackAlert.classList.contains('hidden')) {
        audioElements.push(incorrectFeedbackAlert);
    }
}

export function resetAudioPlayback() {
    audioPlaying = false;
    audioFinished = false;
    audioIndex = 0;
    loadAudio();
}

export function resetAudioForNextQuestion() {
    if (audioPlaying) {
        pauseAudio();
    }

    updateAudioToggleButtonVisibility();
    activated = false;
}

export function updateAudioToggleButtonVisibility() {
    const currentQuestion = document.querySelector('.question.current > div');
    const hasAudio = currentQuestion.dataset.audio ? true : false;

    if (hasAudio) {
        audioToggleButton.classList.remove('d-none');
    } else {
        audioToggleButton.classList.add('d-none');
    }
}

function loadAudio() {
    audioPlayer.src = audioElements[audioIndex].dataset.audio;
    audioPlayer.load();
}

export function playAudio() {
    audioPlayer.play();
    showPauseButton();
    audioPlaying = true;
    audioHighlight.highlight(audioElements[audioIndex]);
}

export function pauseAudio() {
    audioPlayer.pause();
    showPlayButton();
    audioPlaying = false;
    audioHighlight.unhighlight(audioElements[audioIndex]);
}

function showPlayButton() {
    audioToggleButton.classList.add('paused');
    audioToggleButton.classList.remove('playing');
}

function showPauseButton() {
    audioToggleButton.classList.add('playing');
    audioToggleButton.classList.remove('paused');
}

export function setupFeedbackAudioElement(feedbackElement) {
    audioHighlight.unhighlight(audioElements[audioIndex]);
    audioElements = [feedbackElement];
}
